var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoElevvaSupremacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.229,
    height: 28.179,
    viewBox: "0 0 67.229 28.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12299",
    "data-name": "Group 12299",
    transform: "translate(-396.736 -787.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12297",
    "data-name": "Group 12297",
    transform: "translate(396.737 787.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12296",
    "data-name": "Group 12296",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12295",
    "data-name": "Group 12295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7288",
    "data-name": "Path 7288",
    d: "M399.6,965.789a6.367,6.367,0,0,1,3.143-.754,6.9,6.9,0,0,1,3.19.708,5.271,5.271,0,0,1,2.157,1.995,5.9,5.9,0,0,1,.8,3.027,5.984,5.984,0,0,1-.093,1.114h-8.653v.093a3.246,3.246,0,0,0,.835,2.042,2.617,2.617,0,0,0,1.972.742,2.988,2.988,0,0,0,1.659-.429,2.028,2.028,0,0,0,.87-1.264h3.224a4.69,4.69,0,0,1-.9,2.134,4.905,4.905,0,0,1-1.9,1.5,6.419,6.419,0,0,1-2.714.545,7.473,7.473,0,0,1-3.445-.742,5.229,5.229,0,0,1-2.227-2.123,6.438,6.438,0,0,1-.777-3.213,6.648,6.648,0,0,1,.754-3.236A5.291,5.291,0,0,1,399.6,965.789Zm5.127,2.273a2.837,2.837,0,0,0-1.844-.592,2.7,2.7,0,0,0-1.8.615,2.514,2.514,0,0,0-.87,1.659h5.405A2.552,2.552,0,0,0,404.729,968.062Z",
    transform: "translate(-396.737 -956.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7289",
    "data-name": "Path 7289",
    d: "M706.352,787.958v20.121h-3.271V787.958Z",
    transform: "translate(-689.14 -787.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7290",
    "data-name": "Path 7290",
    d: "M817.575,965.789a6.367,6.367,0,0,1,3.143-.754,6.9,6.9,0,0,1,3.19.708,5.272,5.272,0,0,1,2.157,1.995,5.9,5.9,0,0,1,.8,3.027,5.981,5.981,0,0,1-.093,1.114H818.12v.093a3.247,3.247,0,0,0,.835,2.042,2.618,2.618,0,0,0,1.972.742,2.987,2.987,0,0,0,1.659-.429,2.028,2.028,0,0,0,.87-1.264h3.225a4.69,4.69,0,0,1-.9,2.134,4.905,4.905,0,0,1-1.9,1.5,6.419,6.419,0,0,1-2.714.545,7.473,7.473,0,0,1-3.445-.742,5.229,5.229,0,0,1-2.227-2.123,6.437,6.437,0,0,1-.777-3.213,6.648,6.648,0,0,1,.754-3.236A5.292,5.292,0,0,1,817.575,965.789Zm5.127,2.273a2.836,2.836,0,0,0-1.844-.592,2.7,2.7,0,0,0-1.8.615,2.514,2.514,0,0,0-.87,1.659h5.405A2.552,2.552,0,0,0,822.7,968.062Z",
    transform: "translate(-795.689 -956.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7291",
    "data-name": "Path 7291",
    d: "M1294.672,968.095l-2.829,8.584-2.811-8.391-.065-.193h-.085l-1.715,4.732,1.865,5.181.724,2.011h4.059l4.292-11.924Z",
    transform: "translate(-1246.645 -959.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12294",
    "data-name": "Group 12294",
    transform: "translate(51.672 4.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7292",
    "data-name": "Path 7292",
    d: "M1544.371,977.1h-1.67q-2.25,0-2.2-1.949a4.511,4.511,0,0,1-1.6,1.554,4.626,4.626,0,0,1-2.3.534,5.21,5.21,0,0,1-3.213-.916,3.048,3.048,0,0,1-1.218-2.587,3.426,3.426,0,0,1,1.4-2.935,6.8,6.8,0,0,1,4.071-1.032h2.366v-.58a1.553,1.553,0,0,0-.6-1.287,2.551,2.551,0,0,0-1.624-.475,2.587,2.587,0,0,0-1.485.394,1.569,1.569,0,0,0-.7,1.067h-3.155a3.677,3.677,0,0,1,1.624-2.842,6.7,6.7,0,0,1,3.874-1.009,6.081,6.081,0,0,1,3.909,1.113,3.9,3.9,0,0,1,1.38,3.224v4.2a.781.781,0,0,0,.186.6.865.865,0,0,0,.58.162h.371Zm-6.751-5.15a2.7,2.7,0,0,0-1.589.406,1.329,1.329,0,0,0-.568,1.148,1.2,1.2,0,0,0,.475,1,2.04,2.04,0,0,0,1.287.371,2.752,2.752,0,0,0,2.018-.731,2.7,2.7,0,0,0,.766-1.96v-.232Z",
    transform: "translate(-1532.169 -961.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12293",
    "data-name": "Group 12293",
    transform: "translate(12.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7293",
    "data-name": "Path 7293",
    d: "M1801.493,895.517a1.66,1.66,0,0,1,.838-.217,1.7,1.7,0,0,1,.85.217,1.6,1.6,0,0,1,.827,1.421,1.592,1.592,0,0,1-.827,1.409,1.72,1.72,0,0,1-.85.213,1.682,1.682,0,0,1-.838-.213,1.608,1.608,0,0,1-.6-.583,1.559,1.559,0,0,1-.221-.818,1.623,1.623,0,0,1,.823-1.428Zm1.494.3a1.3,1.3,0,0,0-.656-.167,1.279,1.279,0,0,0-.648.167,1.2,1.2,0,0,0-.458.466,1.337,1.337,0,0,0-.167.664,1.28,1.28,0,0,0,.167.648,1.218,1.218,0,0,0,.458.458,1.279,1.279,0,0,0,.648.167,1.3,1.3,0,0,0,.656-.167,1.209,1.209,0,0,0,.458-.462,1.3,1.3,0,0,0,.167-.651,1.314,1.314,0,0,0-.167-.66A1.2,1.2,0,0,0,1802.987,895.816Zm-.082.392a.517.517,0,0,1,.187.419.525.525,0,0,1-.1.315.549.549,0,0,1-.276.2l.388.683h-.427l-.341-.605h-.248v.605h-.388v-1.77h.7A.762.762,0,0,1,1802.905,896.208Zm-.528.691a.332.332,0,0,0,.225-.074.248.248,0,0,0,.085-.2.231.231,0,0,0-.082-.19.356.356,0,0,0-.229-.066h-.287v.528Z",
    transform: "translate(-1800.67 -895.3)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7294",
    "data-name": "Path 7294",
    d: "M1059.1,796.147l-6.3-8.189-6.3,8.189-.012.018h3.5l2.873,8.574,2.825-8.574h3.434Z",
    transform: "translate(-1016.905 -787.958)",
    fill: "#7988f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7295",
    "data-name": "Path 7295",
    d: "M1144.031,1228.9h-4.017l.634,1.7h2.748Z",
    transform: "translate(-1106.189 -1208.833)",
    fill: "#b381be"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12298",
    "data-name": "Group 12298",
    transform: "translate(397.344 812.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7296",
    "data-name": "Path 7296",
    d: "M410.07,1325.185v-3.847h1.358a1.412,1.412,0,0,1,.944.268.942.942,0,0,1,.309.752.908.908,0,0,1-.181.568.844.844,0,0,1-.525.306v.006a.956.956,0,0,1,.592.306.88.88,0,0,1,.219.6.915.915,0,0,1-.35.764,1.606,1.606,0,0,1-1.008.274Zm.291-2.075h1.072q.938,0,.938-.752t-.938-.752h-1.072Zm0,1.807h1.125q.991,0,.991-.769t-.991-.769h-1.125Z",
    transform: "translate(-410.07 -1321.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7297",
    "data-name": "Path 7297",
    d: "M524.77,1321.338l-1.364,2.349v1.5h-.291v-1.5l-1.364-2.349h.344l.752,1.317.414.729.414-.729.752-1.317Z",
    transform: "translate(-516.669 -1321.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7298",
    "data-name": "Path 7298",
    d: "M721.814,1320.057a1.444,1.444,0,0,1,1.451.851l-.245.187a1.175,1.175,0,0,0-.475-.589,1.463,1.463,0,0,0-.755-.181,1.2,1.2,0,0,0-.793.23.709.709,0,0,0-.274.563.606.606,0,0,0,.172.443,1.325,1.325,0,0,0,.644.28l.752.163a1.624,1.624,0,0,1,.793.353.8.8,0,0,1,.233.592.906.906,0,0,1-.181.557,1.19,1.19,0,0,1-.5.379,1.924,1.924,0,0,1-.755.137,1.994,1.994,0,0,1-1.035-.248,1.286,1.286,0,0,1-.574-.685l.256-.2a1.093,1.093,0,0,0,.481.638,1.633,1.633,0,0,0,.883.224,1.485,1.485,0,0,0,.807-.2.651.651,0,0,0,.318-.586.546.546,0,0,0-.175-.408,1.264,1.264,0,0,0-.606-.262l-.793-.175a1.567,1.567,0,0,1-.79-.364.829.829,0,0,1-.236-.6.946.946,0,0,1,.169-.545,1.2,1.2,0,0,1,.481-.4A1.7,1.7,0,0,1,721.814,1320.057Z",
    transform: "translate(-706.152 -1320.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7299",
    "data-name": "Path 7299",
    d: "M853.232,1321.338v2.442a1.444,1.444,0,0,1-.388,1.09,1.792,1.792,0,0,1-2.189,0,1.437,1.437,0,0,1-.391-1.09v-2.442h.291v2.384a1.305,1.305,0,0,0,.3.935,1.4,1.4,0,0,0,1.778,0,1.306,1.306,0,0,0,.3-.935v-2.384Z",
    transform: "translate(-830.232 -1321.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7300",
    "data-name": "Path 7300",
    d: "M986.277,1321.338a1.422,1.422,0,0,1,.953.3,1.148,1.148,0,0,1,0,1.655,1.422,1.422,0,0,1-.953.3h-.985v1.591H985v-3.847Zm-.035,1.982a1.165,1.165,0,0,0,.769-.222.9.9,0,0,0,0-1.268,1.155,1.155,0,0,0-.769-.224h-.95v1.714Z",
    transform: "translate(-958.837 -1321.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7301",
    "data-name": "Path 7301",
    d: "M1106.436,1321.338a1.369,1.369,0,0,1,.915.291,1.1,1.1,0,0,1,.1,1.5,1.154,1.154,0,0,1-.673.347l1.125,1.714h-.344l-1.113-1.684h-.012l-.029.017h-1.1v1.667h-.291v-3.847Zm-.006,1.906a1.076,1.076,0,0,0,.714-.21.75.75,0,0,0,.248-.606.759.759,0,0,0-.248-.609,1.066,1.066,0,0,0-.714-.213H1105.3v1.638Z",
    transform: "translate(-1073.383 -1321.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7302",
    "data-name": "Path 7302",
    d: "M1231.8,1325.185v-3.847h2.629v.268H1232.1v1.486h1.848v.274H1232.1v1.55h2.431v.268Z",
    transform: "translate(-1194.408 -1321.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7303",
    "data-name": "Path 7303",
    d: "M1358.593,1321.338v3.847h-.28v-2.868l.035-.7h-.006l-1.4,3.567h-.268l-1.4-3.567h-.006l.035.7v2.868h-.28v-3.847h.437l1.16,2.914.192.589h.006l.187-.583,1.16-2.92Z",
    transform: "translate(-1312.011 -1321.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7304",
    "data-name": "Path 7304",
    d: "M1497.652,1325.185h-.309l-.484-1.207h-1.836l-.484,1.207h-.309l1.539-3.847h.344Zm-2.524-1.475h1.626l-.816-2.087Z",
    transform: "translate(-1444.892 -1321.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7305",
    "data-name": "Path 7305",
    d: "M1625.851,1322.989a1.425,1.425,0,0,1-.571.761,1.868,1.868,0,0,1-1.888.029,1.634,1.634,0,0,1-.609-.685,2.656,2.656,0,0,1,0-2.11,1.636,1.636,0,0,1,.609-.685,1.7,1.7,0,0,1,.915-.242,1.409,1.409,0,0,1,1.492.95l-.286.134a1.174,1.174,0,0,0-.425-.609,1.292,1.292,0,0,0-.764-.207,1.4,1.4,0,0,0-.761.207,1.361,1.361,0,0,0-.51.592,2.135,2.135,0,0,0-.181.915,2.165,2.165,0,0,0,.178.915,1.358,1.358,0,0,0,.5.592,1.381,1.381,0,0,0,.761.207,1.365,1.365,0,0,0,.793-.224,1.166,1.166,0,0,0,.455-.65Z",
    transform: "translate(-1567.385 -1320.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7306",
    "data-name": "Path 7306",
    d: "M1748.922,1321.338l-1.364,2.349v1.5h-.292v-1.5l-1.364-2.349h.344l.752,1.317.414.729.414-.729.752-1.317Z",
    transform: "translate(-1685.111 -1321.28)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElevvaSupremacy);
export default __webpack_public_path__ + "static/media/logo-elevva-supremacy.1349be8bb881e2741e3298a18c3ec5d9.svg";
export { ForwardRef as ReactComponent };